import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useFileReaderText } from "../../../../hooks";
import { ViewArchiveInfoLoadingIcon } from "../../status";
import { ViewChunkPlainText } from "../text/view-chunk-plain-text.component";
import { fileToDataUrl } from "../../../../utils";
import { ViewerControlButtonDownload, ViewerControlsBox } from "../../controls";
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { InputRadioButtonList } from '@isyc-react/form/modules/input/option/radio';
import '@isyc-react/design/main';
import "./view-html.style.scss";

// TODO view plain text options ...

// TODO implement onViewed callback
// TODO remove html iframe viewer?? xss or something?
export const ViewHtml = props => {
  const {
    file,
    onViewed
  } = props;
  const [loading, setLoading] = React.useState(true);
  const [view, setView] = React.useState({
    id: 'html',
    checked: true
  });
  const [dataUrl, setDataUrl] = React.useState(null);
  const {
    text
  } = useFileReaderText(file);
  React.useEffect(() => {
    fileToDataUrl(file).then(setDataUrl).catch(e => console.error('[HTML parser] Error reading HTML file'));
  }, [file]);
  React.useEffect(() => {
    if (text && dataUrl) {
      setLoading(false);
    }
  }, [text, dataUrl]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-html-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-html-tools"
  }, /*#__PURE__*/React.createElement(InputRadioButtonList, {
    items: [{
      id: 'plain',
      checked: false
    }, {
      id: 'html',
      checked: true
    }],
    value: view,
    labels: ['Plain', 'HTML'],
    onChange: setView
  }), /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file
    },
    name: file.name
  }))), /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-html-document"
  }, loading ? /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: file.name
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, text && dataUrl && /*#__PURE__*/React.createElement(React.Fragment, null, view && view.id === 'plain' ? /*#__PURE__*/React.createElement(ViewChunkPlainText, {
    text: text,
    highlight: {
      enabled: true,
      languages: ['xml']
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "view-html-container-html"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: dataUrl,
    className: "view-html-html"
  })))))));
};